import { useQuery } from "react-query";
import axios from "infra/http";
import { ParametrosAreaComum } from "../typings";

function useParametrosAreaComum(tenantId: string) {
  return useQuery(
    `/v1/parametros-reserva/${tenantId}`,
    async () => {
      const { data } = await axios.get<ParametrosAreaComum>(
        `/v1/parametros-reserva/${tenantId}`
      );

      return data;
    },
    {
      enabled: !!tenantId,
    }
  );
}

export default useParametrosAreaComum;
